import { MultipartUploadError, PantheonApiError } from "@/client/media-upload";

/**
 * Delay before each attempt, indexed by attempts already made. The length is
 * the attempt ceiling, so the two cannot drift apart.
 */
const RETRY_DELAYS_MS = [0, 5_000, 10_000, 20_000, 40_000, 60_000];

/** The delay, or null when the task has no attempts left. */
export function nextRetryDelay(attemptsMade: number): number | null {
  const base = RETRY_DELAYS_MS[attemptsMade];
  if (base === undefined) return null;
  // Jitter so a pantheon outage does not have every student retry in lockstep.
  return base + Math.random() * base * 0.5;
}

function statusOf(error: unknown): number | undefined {
  if (error instanceof MultipartUploadError) return error.status;
  if (error instanceof PantheonApiError) return error.status;
  return undefined;
}

/**
 * Whether a later attempt could still succeed. Unrecognised errors are
 * retryable on purpose.
 */
export function isRetryableUploadError(error: unknown): boolean {
  const status = statusOf(error);
  if (status === undefined) return true;
  const rejected = status >= 400 && status < 500 && status !== 429;
  return !rejected;
}
